import styled from 'styled-components';

const Wrapper = styled.div<{
  width?: string;
  maxWidth?: string;
  margin?: string;
  padding?: string;
  height?: string;
  border?: string;
  className?: string;
}>`
  display: flex;
  flex-flow: column;
  background: #fff;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-width: ${(props) => props.maxWidth};
  margin: ${(props) => props.margin};
  border: ${(props) => props.border || 'none'};
  border-radius: 8px;
  padding: ${(props) => props.padding || '16px'};
  box-shadow: 0px 0px 13px -2px #00000015;
  cursor: pointer;
  :hover {
    ${(props) => props.className === 'setting-page-card' && 'outline: 0.6px solid #1ec252 !important'};
    .arrow-icon svg path {
      fill: #1ec252 !important;
    }
  }
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .global-custom-btn-style {
      font-size: 13px !important;
    }
  }
`;
interface FormProps {
  width?: string;
  maxWidth?: string;
  margin?: string;
  padding?: string;
  height?: string;
  border?: string;
  className?: string;
  onClick?: () => void;
}
const CardLayout: React.FC<FormProps> = (props) => {
  const { width, maxWidth, margin, children, padding, height, border, className, onClick } = props;
  return (
    <Wrapper
      className={className}
      id="card-layout"
      width={width}
      maxWidth={maxWidth}
      margin={margin}
      padding={padding}
      height={height}
      border={border}
      onClick={onClick}
    >
      {children}
    </Wrapper>
  );
};

export default CardLayout;
